var React = require('react');

function FolderOpen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M69.08 271.63L0 390.05V112a48 48 0 0 1 48-48h160l64 64h160a48 48 0 0 1 48 48v48H152a96.31 96.31 0 0 0-82.92 47.63z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M152 256h400a24 24 0 0 1 20.73 36.09l-72.46 124.16A64 64 0 0 1 445 448H45a24 24 0 0 1-20.73-36.09l72.45-124.16A64 64 0 0 1 152 256z","className":"fa-primary","key":2})]);
}

FolderOpen.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = FolderOpen;

FolderOpen.default = FolderOpen;
